/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import { Envelope } from 'types';
import { EnvelopeStatus } from 'types/Envelope';
import EnvelopeTimeline from 'modules/envelopes/components/EnvelopeTimeline';
import EnvelopeDetailsSummaryCard from './EnvelopeDetailsSummaryCard';
import EnvelopeDetailsProgressCard from './EnvelopeDetailsProgressCard';
import EnvelopeDetailsSignersCard from './EnvelopeDetailsSignersCard';

type EnvelopeWithStatus = Envelope & { envelopeStatus?: EnvelopeStatus };

type EnvelopeDetailsContentProps = {
  envelope: EnvelopeWithStatus;
  refetchEnvelope: () => void;
};

const EnvelopeDetailsContent: FC<EnvelopeDetailsContentProps> = ({
  envelope,
  refetchEnvelope,
}) => {
  const { envelopeStatus } = envelope;

  const completedSigners =
    envelopeStatus?.signersStatus.completedSigners.length ||
    envelope.signers?.filter((s) => s.status === 'SIGNED').length ||
    0;
  const totalSigners =
    envelopeStatus?.signersStatus.summary.total ||
    envelope.signers?.length ||
    0;
  const progressPercentage =
    totalSigners > 0 ? (completedSigners / totalSigners) * 100 : 0;

  // Get signers data - prefer envelopeStatus if available
  const signersData = envelopeStatus?.signersStatus || {
    pendingSigners: [],
    completedSigners: [],
    declinedSigners: [],
  };

  // Combine all signers for display
  const allSigners = [
    ...signersData.completedSigners,
    ...signersData.pendingSigners,
    ...signersData.declinedSigners,
  ];

  return (
    <div className="space-y-6 mb-4">
      <EnvelopeDetailsSummaryCard
        envelope={envelope}
        completedSigners={completedSigners}
        totalSigners={totalSigners}
        refetchEnvelope={refetchEnvelope}
      />

      <div className="row g-4">
        <div className="col-lg-9">
          <div className="space-y-4">
            <EnvelopeDetailsProgressCard
              completedSigners={completedSigners}
              totalSigners={totalSigners}
              progressPercentage={progressPercentage}
            />

            <EnvelopeDetailsSignersCard allSigners={allSigners} />
          </div>
        </div>

        <div className="col-lg-3">
          <EnvelopeTimeline
            envelope={envelope}
            completedSigners={completedSigners}
            progressPercentage={progressPercentage}
            invertedDirection
            uniformMarkers
          />
        </div>
      </div>
    </div>
  );
};

export default EnvelopeDetailsContent;
